import React from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'formik'

import Checkbox from 'components/Forms/FormElements/Checkbox'
import FormElementGroup from 'components/FormElements/FormElementGroup'
import RadioGroup from 'components/Forms/FormElements/RadioGroup'

const UserServiceSettingsSection = () => {
    const { t } = useTranslation('editProfile')

    return (
        <div className="user-service-settings-section">
            <FormElementGroup cssClass="cols-1">
                <Field name="emailNotifyFavoriteAdPriceDrop">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('editProfile:details.serviceSetting.fields.emailNotifyFavoriteAdPriceDrop.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field name="allowMarketing">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('editProfile:details.serviceSetting.fields.allowMarketing.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field name="openResultPageInNewWindow">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('editProfile:details.serviceSetting.fields.openResultPageInNewWindow.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field name="showPriceHistory">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('editProfile:details.serviceSetting.fields.showPriceHistory.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field name="language">
                    {props => (
                        <RadioGroup
                            {...props}
                            name="language"
                            type="radio"
                            options={[
                                { value: 'finnish', name: t('editProfile:details.serviceSetting.fields.language.finnish') },
                                { value: 'english', name: t('editProfile:details.serviceSetting.fields.language.english') }
                            ]}
                            orientation="horizontal"
                            label={t('editProfile:details.serviceSetting.fields.language.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
        </div>
    )
}

export default UserServiceSettingsSection
